// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1767":"3f1751748e5b301f28c6","1790":"034bee7f8c3ff35e2b64","8324":"be36ec01bd3300d3169b"}[chunkId] + ".js";
};